import { render, staticRenderFns } from "./PatientWrapper.vue?vue&type=template&id=20f5de30&"
import script from "./PatientWrapper.vue?vue&type=script&lang=js&"
export * from "./PatientWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PatientWrapper.vue?vue&type=style&index=0&id=20f5de30&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports